"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetAvailableCountryIdsQuery = exports.useGetCountriesQuery = exports.useGetAvailableCountries = exports.makeSelectAvailableCountries = exports.countriesAdapter = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _react = require("react");

var _EmptyAppApi = require("../EmptyAppApi");

var countriesAdapter = (0, _toolkit.createEntityAdapter)();
exports.countriesAdapter = countriesAdapter;

var countries = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getCountries: build.query({
        query: function query() {
          return '/api/v1/countries';
        },
        transformResponse: function transformResponse(response) {
          return countriesAdapter.addMany(countriesAdapter.getInitialState(), response.data);
        }
      }),
      getAvailableCountryIds: build.query({
        query: function query() {
          return '/api/v1/available-countries';
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      })
    };
  }
});

var makeSelectAvailableCountries = function makeSelectAvailableCountries(isInternational) {
  return (0, _reselect.createSelector)(countries.endpoints.getCountries.select(), countries.endpoints.getAvailableCountryIds.select(), function (countriesState, availableCountryIdsState) {
    var _countriesState$data;

    return (countriesState === null || countriesState === void 0 ? void 0 : (_countriesState$data = countriesState.data) === null || _countriesState$data === void 0 ? void 0 : _countriesState$data.entities) ? Object.values(countriesState.data.entities).filter(function (country) {
      var _availableCountryIdsS, _availableCountryIdsS2;

      return country && (isInternational || !isInternational && !country.isInternational) && !!(availableCountryIdsState === null || availableCountryIdsState === void 0 ? void 0 : (_availableCountryIdsS = availableCountryIdsState.data) === null || _availableCountryIdsS === void 0 ? void 0 : (_availableCountryIdsS2 = _availableCountryIdsS.includes) === null || _availableCountryIdsS2 === void 0 ? void 0 : _availableCountryIdsS2.call(_availableCountryIdsS, country.id));
    }) : [];
  });
};

exports.makeSelectAvailableCountries = makeSelectAvailableCountries;

var useGetAvailableCountries = function useGetAvailableCountries(_ref) {
  var isInternational = _ref.isInternational;
  var availableCountryIdsQuery = countries.useGetAvailableCountryIdsQuery();
  var countriesQuery = countries.useGetCountriesQuery();
  var data = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return makeSelectAvailableCountries(isInternational);
  }, [isInternational]));
  return {
    isLoading: countriesQuery.isLoading || availableCountryIdsQuery.isLoading,
    data: data
  };
};

exports.useGetAvailableCountries = useGetAvailableCountries;
var useGetCountriesQuery = countries.useGetCountriesQuery,
    useGetAvailableCountryIdsQuery = countries.useGetAvailableCountryIdsQuery;
exports.useGetAvailableCountryIdsQuery = useGetAvailableCountryIdsQuery;
exports.useGetCountriesQuery = useGetCountriesQuery;